module.exports = __webpack_public_path__ + "img/845.3fe874b1.gif";